import { ScheduledPostsClient } from 'api/clients/ScheduledPostsClient'
import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { UseMutationOptions, useMutation } from 'react-query'

interface Props {
  scheduledPostId: number
}

interface Data {
  caption: string
}

interface Variables {
  userMessage?: string
  provider?: ExternalIntegrationEnum
}

type Options = Omit<UseMutationOptions<Data, unknown, Variables>, 'mutationKey' | 'mutationFn'>

const fetchCaption = async (
  workspaceId: number,
  scheduledPostId: number,
  userMessage?: string,
  provider?: ExternalIntegrationEnum,
) => {
  const res = await ScheduledPostsClient.generateCaption({ workspaceId, scheduledPostId, userMessage, provider })
  if (res.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error('Error generating caption')
  }
  return res.data
}

export const useGenerateCaption = ({ scheduledPostId }: Props, options?: Options) => {
  const workspaceId = useCurrentWorkspaceId()
  return useMutation<Data, unknown, Variables>(
    ['captions', scheduledPostId],
    ({ userMessage, provider }) => fetchCaption(workspaceId, scheduledPostId, userMessage, provider),
    options,
  )
}
